import { useAuthState } from 'shared/stores';

export function useUser() {
    const authState = useAuthState();
    const user = authState.user.get();
    return user;
}
